import React from "react";

import b64 from "base-64";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { AiTwotoneEye, AiTwotoneEyeInvisible } from "react-icons/ai";

import { Mensagem } from "../../../componentes";
import { UpdateSenha } from "../../../servicos";
import { BgQuadrado, Wrapper, Erro } from "./styles";

export default function AtualizarSenha() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [mensagem, setMensagem] = React.useState("");
  const [tipo, setTipo] = React.useState("");
  const [type, setType] = React.useState("password");
  const [typeNew, setTypeNew] = React.useState("password");
  const [exibirAlteracaoSenha, setExibirAlteracaoSenha] = React.useState(false);

  const onSubmitUpdate = (data: any) => {
    updateSenha(data.email, data.senha, data.novaSenha);
  };

  const updateSenha = async (
    email: string,
    senha: string,
    novaSenha: string
  ) => {
    if (navigator.onLine) {
      try {
        const senhaB64 = b64.encode(senha);
        const novaSenhaB64 = b64.encode(novaSenha);

        const resultado = await UpdateSenha(email, senhaB64, novaSenhaB64);
        if (resultado.success) {
          setMensagem("Senha atualizada com sucesso!");
          setTipo("sucesso");
          setExibirAlteracaoSenha(true);
        } else {
          console.log(resultado);
        }
      } catch (err) {
        setMensagem("E-mail ou senha incorreto!");
        setTipo("erro");
      }
    } else {
      setMensagem("É necessário conexão com a internet!");
      setTipo("erro");
    }

    setTimeout(() => {
      setMensagem("");
    }, 5000);
  };

  const mostrarSenha = () => {
    setType(type === "password" ? "text" : "password");
  };

  const mostrarSenhaNova = () => {
    setTypeNew(typeNew === "password" ? "text" : "password");
  };

  return (
    <Wrapper>
      <BgQuadrado />
      {!exibirAlteracaoSenha ? (
        <form onSubmit={handleSubmit(onSubmitUpdate)}>
          <h2>ATUALIZAR SENHA</h2>
          <input
            {...register("email", { required: true })}
            placeholder="E-mail"
          />
          {errors.email && (
            <Erro>
              <span>O campo Email é obrigatório!</span>
            </Erro>
          )}
          <div className="container-password">
            <input
              {...register("senha", { required: true })}
              placeholder="Senha atual"
              type={type}
            />
            <button type="button" onClick={mostrarSenha}>
              {type === "password" ? (
                <AiTwotoneEyeInvisible />
              ) : (
                <AiTwotoneEye />
              )}
            </button>
          </div>
          {errors.senha && (
            <Erro>
              <span>O campo Senha é obrigatório!</span>
            </Erro>
          )}
          <div className="container-password">
            <input
              {...register("novaSenha", { required: true })}
              placeholder="Nova Senha"
              type={typeNew}
            />
            <button type="button" onClick={mostrarSenhaNova}>
              {typeNew === "password" ? (
                <AiTwotoneEyeInvisible />
              ) : (
                <AiTwotoneEye />
              )}
            </button>
          </div>
          {errors.novaSenha && (
            <Erro>
              <span>O campo Nova Senha é obrigatório!</span>
            </Erro>
          )}

          <input className="input-submit" type="submit" value="Atualizar" />
        </form>
      ) : (
        <div>
          <h2>Parabéns!</h2>
          <h2>Sua senha foi alterada com sucesso!</h2>
          <br />
        </div>
      )}

      <Link to="/login">Faça login</Link>
      {mensagem ? <Mensagem tipo={tipo} frase={mensagem} /> : null}
    </Wrapper>
  );
}
